var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46403 6.6914C1.24283 7.01908 0.34375 8.13371 0.34375 9.45833V12.5833C0.34375 14.1654 1.62627 15.4479 3.20833 15.4479H5.8125C6.24397 15.4479 6.59375 15.0981 6.59375 14.6667V7.375C6.59375 6.94353 6.24397 6.59375 5.8125 6.59375H4.05711C4.50416 4.02086 7.12356 1.90625 10.5 1.90625C13.8764 1.90625 16.4958 4.02086 16.9429 6.59375H15.1875C14.756 6.59375 14.4062 6.94353 14.4062 7.375V14.6667C14.4062 15.0981 14.756 15.4479 15.1875 15.4479H16.9198C16.5671 16.941 15.2258 18.0521 13.625 18.0521H12.4319C12.1228 17.2886 11.3743 16.75 10.5 16.75C9.34941 16.75 8.41667 17.6827 8.41667 18.8333C8.41667 19.9839 9.34941 20.9167 10.5 20.9167C11.3743 20.9167 12.1228 20.3781 12.4319 19.6146H13.625C16.1248 19.6146 18.1916 17.7608 18.5257 15.353C19.7521 15.0288 20.6562 13.9117 20.6562 12.5833V9.45833C20.6562 8.13371 19.7572 7.01909 18.536 6.6914C18.1386 3.04124 14.5898 0.34375 10.5 0.34375C6.4102 0.34375 2.86138 3.04124 2.46403 6.6914Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.d5fd96c92404c65b0799bd3f348f69de.svg";
export { ForwardRef as ReactComponent };